import BerlitzButton from '@berlitzplatforms/micro.ui.button'
import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-select-selection {
    ${({ theme }) => `
      font-size: ${theme.fontSize.xl};
      font-weight: ${theme.fontWeight.bold};
      padding-left: 11px;
      padding-top: 2px;
      height: 46px;
    `};
  }

  .block-modal {
    .ant-select-selection {
      ${({ theme }) => `
      font-size: ${theme.fontSize.xs};
      font-weight: ${theme.fontWeight.regular};
      padding-left: 6px;
      padding-top: 8px;
      height: 36px;
    `};
    }
  }
`

export const Contents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }
`

export const Loaders = styled.div`
  ${() => `
    display: flex;
    width: 100%;

    span[aria-busy="true"] {
      margin: 4px 10px;
    }
  `}
`

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;

  .profile-info {
    display: flex;
    flex-direction: row;

    .profile-attrs {
      display: flex;
      flex-direction: column;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 208px;
    flex-direction: column;
    justify-content: center;

    .profile-info {
      display: flex;
      flex-direction: column;

      .profile-attrs {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
`

export const Button = styled(BerlitzButton)`
  ${({ theme }) => `
    padding: ${theme.space.xs} ${theme.space.md};
    margin-left: ${theme.space.xs};
  `}
`

export const ProfileInfoAvatar = styled.div`
  ${({ theme }) => `
    margin-bottom: 21px;
    margin-right: 17px;

    div[type="profile"] {
      width: 102px;
      height: 102px;
    }

    @media (min-width: ${theme.breakpoints.md}) {
      align-self: center;
      margin-right: 0px;

      div[type="profile"] {
        width: 132px;
        height: 132px;
      }
    }
  `}
`

export const ProfileInfoActions = styled.div<{
  isFaved?: boolean
  isFaveDisabled?: boolean
  isBlockDisabled?: boolean
}>`
  ${({ theme, isFaved, isFaveDisabled, isBlockDisabled }) => `
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    svg {
      font-size: 32px;
      color: ${isFaved ? theme.palette.red100 : theme.palette.blueGray40};
      cursor: ${isFaveDisabled ? 'default' : 'pointer'};
    }

    @media (min-width: ${theme.breakpoints.md}) {
      margin-bottom: 19px;
    }

    button {
      width: max-content;
    }

    .block-icon {
      margin-left: 8px;
      border-radius: 100%;
      background-color: white;

      svg {
        color: ${theme.palette.blueGray40};
        cursor: ${isBlockDisabled ? 'default' : 'pointer'};
      }

      &.blocked {
        svg {
          color: ${theme.palette.red100};
        }
      }
    }
  `}
`

export const ProfileInfoAttr = styled.div`
  ${({ theme }) => `
    align-self: flex-start;
    margin-bottom: ${theme.space.xs};

    @media (min-width: ${theme.breakpoints.md}) {
      margin-bottom: ${theme.space.md};
    }
  `}
`

export const ProfileInfoAttrItem = styled.div`
  ${() => `
    display: flex;
    align-items: initial;
    margin-bottom: 9px;
  `}
`

export const ProfileInfoAttrItemIcon = styled.div`
  ${({ theme }) => `
    margin-right: ${theme.space.xxs};

    svg {
      margin: 0;
      padding: 0;
      font-size: 20px;
    }
  `}
`

export const ProfileInfoAttrItemInfo = styled.div`
  ${({ theme }) => `
    font-size: 16px;
    font-weight: ${theme.fontWeight.regular};
    line-height: 1.38;
    letter-spacing: 0.56px;

    strong {
      font-weight: ${theme.fontWeight.bold};
    }
  `}
`

export const ProfileInfoDesc = styled.div`
  ${({ theme }) => `
    align-self: flex-start;
    font-size: ${theme.fontSize.xxs};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.49px;
    margin-bottom: ${theme.space.md};
  `}
`

export const RightInfo = styled.div`
  ${({ theme }) => `
    width: 100%;

    .video {
      margin-bottom: ${theme.space.md};

      .about-me {
        .header {
          font-size: ${theme.fontSize.md};
          font-weight: ${theme.fontWeight.bold};
          line-height: 1.33;
          letter-spacing: 0.73px;
        }

        .body {
          font-size: ${theme.fontSize.xxs};
          line-height: 1.14;
          letter-spacing: 0.49px;
        }
      }

      .empty-video {
        padding: 51px 0;
        border: 1px solid ${theme.palette.blue30};
        margin-bottom: ${theme.space.md};
        font-size: 16px !important;
        display: flex;
        flex-direction: column;
        align-items: center;

        svg {
          width: 270px;
          height: 199px;
        }
      }

      .star-rating-wrapper {
        display: none;
      }
    }

    .calendar {
      .body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .empty-calendar {
          div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          svg {
            width: 167px;
            height: 124px;
          }
        }
      }

      .star-rating-wrapper {
        display: block;
      }
    }

    @media (min-width: ${theme.breakpoints.md}) {
      width: calc(100% - 208px - 22px);
      margin-bottom: ${theme.space.md};
      flex-direction: row;

      .video {
        .star-rating-wrapper {
          display: none;
        }
      }

      .calendar {
        .star-rating-wrapper {
          display: block;
        }
      }
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      width: calc(100% - 208px - 22px);
      margin-bottom: ${theme.space.md};
      flex-direction: row;

      .video {
        .star-rating-wrapper {
          display: block;
        }
      }

      .calendar {
        .star-rating-wrapper {
          display: none;
        }
      }
    }
  `}
`

export const AverageRatingWrapper = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xxs};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.49px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 12px;
    background-color: ${theme.palette.white};
    border-radius: 3px;
  `}
`

export const ProfileAvailability = styled.div`
  ${({ theme }) => `
    background-color: ${theme.palette.white};
    border-radius: 3px;
    display: grid;
    align-items: center;
    justify-content: center;
  `}
`
